import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const updateBottomNavIconDesignSelector = createSelector(testTargetOffersSelector, offers => offers.updateBottomNavIconDesign || Empty.Object);

export { updateBottomNavIconDesignSelector };
